import React from 'react';
import LazyVideo from '../../../../Components/LazyVideo/LazyVideo';
import './Youtube.scss';

const ReactYoutube = (props) => {
    const {link, title = 'Video'} = props;
    return <LazyVideo link={link} title={title} className="youtube"/>;
}

export default ReactYoutube;
